module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-500.1b00894e.jpg";